import React, { useRef } from "react";
import { FaHeart, FaShoppingCart, FaEye, FaStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useCountry } from "./CountryContext";
import "./ProductCardsSection.css";

// =========================
// FEATURED PRODUCT IMAGES
// =========================

import img1 from "../Images/green6.jpg";
import img2 from "../Images/image33.png";
import img3 from "../Images/mix1.jpg";
import img4 from "../Images/orange3.jpg";
import img5 from "../Images/yellowblue3.jpg";
import img6 from "../Images/red3.jpg";
import img7 from "../Images/yellow7.jpg";
import img8 from "../Images/orange10.jpg";
import img9 from "../Images/blue3.jpg";
import img10 from "../Images/south7.jpeg";

// =========================
// FEATURED PRODUCTS
// IMPORTANT:
// IDs 301 - 310 are used so
// they don't conflict with Men's 1 - 8
// =========================

const shopProductsData = [
  {
    id: 301,
    name: "African Dress 1",
    price: 149.99,
    discount: 20,
    rating: 4.5,
    img: img1,
  },
  {
    id: 302,
    name: "African Dress 2",
    price: 159.99,
    discount: 15,
    rating: 4.2,
    img: img2,
  },
  {
    id: 303,
    name: "African Dress 3",
    price: 129.99,
    discount: 10,
    rating: 4.8,
    img: img3,
  },
  {
    id: 304,
    name: "African Dress 4",
    price: 189.99,
    discount: 25,
    rating: 4.1,
    img: img4,
  },
  {
    id: 305,
    name: "African Dress 5",
    price: 139.99,
    discount: 5,
    rating: 4.6,
    img: img5,
  },
  {
    id: 306,
    name: "African Dress 6",
    price: 169.99,
    discount: 30,
    rating: 4.3,
    img: img6,
  },
  {
    id: 307,
    name: "African Dress 7",
    price: 119.99,
    discount: 10,
    rating: 4.9,
    img: img7,
  },
  {
    id: 308,
    name: "African Dress 8",
    price: 199.99,
    discount: 20,
    rating: 4.7,
    img: img8,
  },
  {
    id: 309,
    name: "African Dress 9",
    price: 199.99,
    discount: 20,
    rating: 4.7,
    img: img9,
  },
  {
    id: 310,
    name: "African Dress 10",
    price: 199.99,
    discount: 20,
    rating: 4.7,
    img: img10,
  },
];

function ProductCardsSection() {
  const shopScrollRef = useRef(null);

  const navigate = useNavigate();

  const { formatPrice } = useCountry();

  // =========================
  // DISCOUNTED PRICE
  // =========================

  const getDiscountedPrice = (product) => {
    return Number(
      (
        product.price -
        (product.price * product.discount) / 100
      ).toFixed(2)
    );
  };

  // =========================
  // PRODUCT DETAILS
  // =========================

  const handleProductClick = (id) => {
    navigate(`/womens/${id}`);
  };

  // =========================
  // SCROLL
  // =========================

  const handleScroll = (direction) => {
    if (!shopScrollRef.current) return;

    const scrollAmount = 320;

    if (direction === "left") {
      shopScrollRef.current.scrollLeft -= scrollAmount;
    } else {
      shopScrollRef.current.scrollLeft += scrollAmount;
    }
  };

  return (
    <>
      <div className="container my-5 shop-products-wrapper">

        {/* =========================
            HEADER
        ========================== */}

        <div className="shop-products-header d-flex justify-content-between align-items-center mb-3">

          <h4 id="discover">
            Featured Products
          </h4>

          <div className="shop-products-arrows">

            <button
              onClick={() => handleScroll("left")}
              className="btn btn-outline-dark me-2"
            >
              ‹
            </button>

            <button
              onClick={() => handleScroll("right")}
              className="btn btn-outline-dark"
            >
              ›
            </button>

          </div>
        </div>

        {/* =========================
            PRODUCTS
        ========================== */}

        <div
          className="shop-products-scroll-area"
          ref={shopScrollRef}
        >

          {shopProductsData.map((item) => {

            const discountedPrice =
              getDiscountedPrice(item);

            return (
              <div
                className="shop-product-card"
                key={item.id}
              >

                {/* =========================
                    PRODUCT IMAGE
                ========================== */}

                <div className="shop-product-imgbox">

                  <img
                    src={item.img}
                    alt={item.name}
                    data-aos="zoom-in"
                    onClick={() =>
                      handleProductClick(item.id)
                    }
                    style={{
                      cursor: "pointer",
                    }}
                  />

                  {/* =========================
                      PRODUCT ICONS
                  ========================== */}

                  <div className="shop-product-icons">

                    {/* HEART */}

                    <span>
                      <FaHeart />
                    </span>

                    {/* CART */}

                    <span
                      onClick={() =>
                        handleProductClick(item.id)
                      }
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <FaShoppingCart />
                    </span>

                    {/* EYE */}

                    <span
                      onClick={() =>
                        handleProductClick(item.id)
                      }
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <FaEye />
                    </span>

                  </div>
                </div>

                {/* =========================
                    PRODUCT DETAILS
                ========================== */}

                <div className="shop-product-body">

                  <h6>
                    {item.name}
                  </h6>

                  {/* RATING */}

                  <div className="shop-product-rating">

                    <FaStar /> {item.rating}

                  </div>

                  {/* =========================
                      PRICE
                  ========================== */}

                  <div className="shop-product-price">

                    <span className="shop-discounted-price">
                      {formatPrice(discountedPrice)}
                    </span>

                    <span>
                      {formatPrice(item.price)}
                    </span>

                    <b>
                      {item.discount}% off
                    </b>

                  </div>

                  {/* =========================
                      BUY NOW
                  ========================== */}

                  <button
                    className="btn1 w-100 mt-2 shop-buy-btn"
                    onClick={() =>
                      handleProductClick(item.id)
                    }
                  >
                    Buy Now
                  </button>

                </div>

              </div>
            );
          })}

        </div>
      </div>
    </>
  );
}

export default ProductCardsSection;

